import { render } from "./SelectGroup.vue?vue&type=template&id=10c1000e&scoped=true"
import script from "./SelectGroup.vue?vue&type=script&lang=js"
export * from "./SelectGroup.vue?vue&type=script&lang=js"

import "./SelectGroup.vue?vue&type=style&index=0&id=10c1000e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10c1000e"]])

export default __exports__